import { render, staticRenderFns } from "./RoomServicePage.vue?vue&type=template&id=140b1da5&scoped=true&"
import script from "./RoomServicePage.vue?vue&type=script&lang=ts&"
export * from "./RoomServicePage.vue?vue&type=script&lang=ts&"
import style0 from "./RoomServicePage.vue?vue&type=style&index=0&id=140b1da5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140b1da5",
  null
  
)

export default component.exports